import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const outreach = defineConnector({
  identifier: "outreach",
  name: "Outreach",
  tagLine: "Sales engagement platform",
  keywords:
    "sales engagement sequences prospects accounts cadence sdr prospecting",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://api\\.outreach\\.io/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an Outreach OAuth app",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Outreach](https://www.outreach.io/) account. Go to **Settings → Integrations → Installed Apps**, create or select an app, then open **Set-up → API access** to find your credentials.",
        },
      ],
    },
    {
      title: "Enter your OAuth credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Configure OAuth redirect URI",
      items: [
        {
          kind: "markdown",
          content:
            "In your Outreach app settings under **OAuth**, add the following redirect URL:",
        },
        {
          kind: "copyable",
          label: "Redirect URL",
          value: "{API_URL}/connected-apps/oauth/outreach/callback",
        },
      ],
    },
    {
      title: "Define scopes",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://developers.outreach.io/api/scopes/) in a space-separated list below. Common scopes include `prospects.read accounts.read users.read`.",
        },
        {
          kind: "input",
          label: "Scopes",
          placeholder: "prospects.read accounts.read users.read",
          required: true,
          defaultValue: "users.read",
          helperText: "Space-separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Outreach account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.outreach.io/oauth/authorize",
    tokenEndpoint: () => "https://api.outreach.io/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.outreach.io/api/v2/users?page[size]=1",
  },
});
